import { render } from "./ClientAdmins.vue?vue&type=template&id=0e77e8c2&scoped=true"
import script from "./ClientAdmins.vue?vue&type=script&lang=js"
export * from "./ClientAdmins.vue?vue&type=script&lang=js"

import "./ClientAdmins.vue?vue&type=style&index=0&id=0e77e8c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e77e8c2"]])

export default __exports__